import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { JwtService } from './jwt.service';
import { DecodedToken } from './jwt.service';

@Injectable({
  providedIn: 'root'
})
export class BaseHttpService {
  constructor(private jwtService: JwtService, public http: HttpClient) {}

  protected getAuthHeaders(): HttpHeaders {
    const token = this.jwtService.getToken();
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    });
  }

  protected getAuthHeadersMultipart(): HttpHeaders {
    const token = this.jwtService.getToken();
    return new HttpHeaders({
      'accept': '*/*',
      'Authorization': `Bearer ${token}`
    });
  }

  protected retrieveAllFromKey<T = Record<string, Record<string, string>>>(url: string, body: Record<string, unknown>): Observable<T[]> {
    return this.http.post<T[]>(url, body, { headers: this.getAuthHeaders() });
  }

  protected retrieveFromKey<T = Record<string, Record<string, string>>>(url: string, body: Record<string, unknown>): Observable<T> {
    return this.http.post<T>(url, body, { headers: this.getAuthHeaders() });
  }


  protected getUserByToken(): DecodedToken | null {
    return this.jwtService.decodeToken();
  }
}
